var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:(("color: " + _vm.computedColor + ";"))},[(_vm.showCheckbox)?_c('v-icon',{attrs:{"color":_vm.computedColor}},[_vm._v("mdi-check-circle-outline")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }